<div class="w-full min-h-screen justify-center flex flex-col items-center bg-gray-100 overflow-hidden">
  <p class="font-bold text-9xl">403</p>
  <p class="font-bold text-2xl">Forbidden</p>
  <p>We're sorry, but you do not have access to this page.</p>
</div>
